import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { CompanyTaxType, PageResponseV2 } from '../models/empresa.model';

@Injectable({
  providedIn: 'root'
})
export class CompanyTaxTypeApiService {
  private readonly apiUrl = `${environment.apiUrl}api/company-tax-types`;

  constructor(private http: HttpClient) { }

  // GET /api/company-tax-types - List all tax types (paginated)
  getAll(params?: { countryId?: number; page?: number; size?: number }): Observable<PageResponseV2<CompanyTaxType>> {
    let queryParams = new HttpParams();
    if (params?.countryId != null) queryParams = queryParams.set('countryId', params.countryId);
    if (params?.page != null) queryParams = queryParams.set('page', params.page);
    if (params?.size != null) queryParams = queryParams.set('size', params.size);
    return this.http.get<PageResponseV2<CompanyTaxType>>(this.apiUrl, { params: queryParams });
  }

  // GET /api/company-tax-types/{id} - Get by ID
  getById(id: number): Observable<CompanyTaxType> {
    return this.http.get<CompanyTaxType>(`${this.apiUrl}/${id}`);
  }

  // POST /api/company-tax-types - Create (requires Sales Rep or higher)
  create(companyTaxType: Omit<CompanyTaxType, 'id'>): Observable<CompanyTaxType> {
    return this.http.post<CompanyTaxType>(this.apiUrl, companyTaxType);
  }

  // PUT /api/company-tax-types/{id} - Update (requires Sales Rep or higher)
  update(id: number, companyTaxType: Omit<CompanyTaxType, 'id'>): Observable<CompanyTaxType> {
    return this.http.put<CompanyTaxType>(`${this.apiUrl}/${id}`, companyTaxType);
  }

  // DELETE /api/company-tax-types/{id} - Delete (requires Admin or higher)
  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
